import type { CommunicationData } from '@app/application/communication/types'
import { identifyPresentationMode } from '@app/application/behaviors/setup-appcues'
import SFetch from '@app/utils/sfetch'

export async function getCommunication(
  endpointParams: Record<string, string> = {}
): Promise<CommunicationData> {
  let url: string

  if (endpointParams.pastMeetings) {
    url = window.Silverfin.Routes.client_meetings_past_communications_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId
    )
  } else {
    url = window.Silverfin.Routes.client_meetings_communications_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId
    )
  }

  return (await SFetch.json(url)) as CommunicationData
}

export async function setOrder(
  order: string[],
  meetingId?: number
): Promise<void> {
  const url = window.Silverfin.Routes.client_meetings_order_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  await SFetch.json(url, {
    method: 'PUT',
    body: { order, meeting_id: meetingId },
  })
}

export async function getAISuggestions(): Promise<string[] | null> {
  const url = window.Silverfin.Routes.client_meetings_ai_suggestions_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  return await SFetch.json(url)
}

export async function removeAISuggestion(
  suggestion: string,
  remarkId: number
): Promise<void> {
  const url = window.Silverfin.Routes.client_meetings_remove_ai_suggestion_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  await SFetch.json(url, {
    method: 'POST',
    body: { suggestion, new_remark_id: remarkId },
  })
}

export async function process(): Promise<void> {
  const url = window.Silverfin.Routes.client_meetings_process_flow_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  await SFetch.raw(url, {
    method: 'POST',
  })
}

export async function enablePresentationMode(
  talkingPointCount: number
): Promise<void> {
  const url = window.Silverfin.Routes.client_meetings_presentation_mode_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  await SFetch.raw(url, {
    method: 'POST',
  })

  identifyPresentationMode(true)
  window.heap?.track('Talking Points: Present Mode Started', {
    talking_point_count: talkingPointCount,
  })
}

export async function disablePresentationMode(): Promise<void> {
  // Presentation mode is session-wide and can be switched off from firm-level
  // pages, where there is no current company.
  const url = window.Silverfin.currentCompanyId
    ? window.Silverfin.Routes.client_meetings_presentation_mode_path(
        window.Silverfin.currentFirmId,
        window.Silverfin.currentCompanyId
      )
    : window.Silverfin.Routes.firm_client_meetings_presentation_mode_path({
        firm_id: window.Silverfin.currentFirmId,
      })

  await SFetch.raw(url, {
    method: 'DELETE',
  })

  identifyPresentationMode(false)
  window.heap?.track('Talking Points: Present Mode Stopped', {})
}
